module.exports = __webpack_public_path__ + "json/market12-0.json?ed32d83d8b6d7de6f67c7f7bf49570a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market12-0.json
// module id = 1255
// module chunks = 3